// SortDropdown.jsx
import React, { useRef, useEffect } from 'react';
import { Box, Button, Typography, Tooltip } from '@mui/material';

const SortDropdown = ({ satellite, sortConfig, toggleSort }) => {
  const sortRef = useRef(null);

  // Safe config (always string key)
  const rawCfg = sortConfig[satellite] || { field: 'Date', direction: 'desc' };
  const cfg = {
    key: String(rawCfg.key || rawCfg.field || 'Date'),
    direction: rawCfg.direction === 'asc' ? 'asc' : 'desc'
  };

  // close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sortRef.current && !sortRef.current.contains(event.target)) {
        const menu = sortRef.current.querySelector('.sort-menu');
        if (menu) menu.style.display = 'none';
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Label for button
  const label = `${cfg.key} ${cfg.direction === 'asc' ? '↑' : '↓'}`;

  return (
    <Tooltip title="Sort options" arrow>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography sx={{ fontSize: 11, color: '#76b6ff' }}>Sort by:</Typography>

        <Box ref={sortRef} sx={{ position: 'relative' }}>
          {/* BUTTON */}
          <Button
            variant="text"
            sx={{
              color: '#fff',
              fontSize: '11px',
              textTransform: 'none',
              padding: '2px 6px',
              border: '1px solid #76b6ff50',
              borderRadius: '4px',
              minWidth: '50px',
            }}
            onClick={(e) => {
              const menu = e.currentTarget.nextSibling;
              menu.style.display =
                menu.style.display === 'block' ? 'none' : 'block';
            }}
          >
            {label}
          </Button>

          {/* DROPDOWN */}
          <Box
            className="sort-menu"
            sx={{
              display: 'none',
              position: 'absolute',
              top: '28px',
              left: 0,
              background: '#1E2126',
              border: '1px solid #76b6ff50',
              borderRadius: '6px',
              padding: '6px 0',
              zIndex: 9999,
              minWidth: '120px',
            }}
          >
            {[
              { field: 'Date', label: 'Date' },
              { field: 'Cloud', label: 'Cloud' },
              { field: 'AOI', label: 'AOI Coverage' },
              { field: 'Off_nadir', label: 'Off-Nadir Angle' },
              { field: 'Sun', label: 'Sun Elevation' },
            ].map(({ field, label }) => (
              <Box
                key={field}
                sx={{
                  px: 1.2,
                  py: 0.7,
                  fontSize: '11px',
                  color: '#fff',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'space-between',
                  '&:hover': {
                    background: 'rgba(255,255,255,0.08)',
                  },
                }}
                onClick={() => toggleSort(satellite, field)}
              >
                <span>{label}</span>

                <span>
                  {cfg.key === field
                    ? cfg.direction === 'asc'
                      ? '↑'
                      : '↓'
                    : ''}
                </span>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Tooltip>
  );
};

export default SortDropdown;
